<template>
    <div class="contenedor_modal">
        <div class="contenedor_modal_cuerpo">
            <div class="contenedor_modal_cabecera">
                <button type="button" class="btn btn-sm btn-danger" @click="cerrar"><i
                        class="fas fa-times"></i></button>
            </div>

            <b-container fluid="">
                <b-row>
                    <div class="col-sm-12 mt-3">
                        <h3>
                            Formulario de Anticipos
                        </h3>
                    </div>

                    <div class="col-sm-12 mt-3">
                        <label for="tipo_pago" class="form-label">Tipo de Pago</label>
                        <select id="tipo_pago" class="form-control form-control-sm" v-model="tipo_pago">
                            <option value="">Seleccionar</option>
                            <option value="efectivo">Efectivo</option>
                            <option value="tarjeta">Tarjeta</option>
                            <option value="ambos">Ambos</option>
                        </select>
                    </div>

                    <!-- MODO EFECTIVO -->

                    <div v-if="tipo_pago == 'efectivo' || tipo_pago == 'ambos'"
                        :class="tipo_pago == 'ambos' ? 'col-sm-6 mt-3' : 'col-sm-12 mt-3'">
                        <label for="" class="form-label">Monto efectivo</label>
                        <input type="number" class="form-control form-control-sm" v-model="monto">
                    </div>

                    <div v-if="tipo_pago == 'tarjeta' || tipo_pago == 'ambos'"
                        :class="tipo_pago == 'ambos' ? 'col-sm-6 mt-3' : 'col-sm-12 mt-3'">
                        <label for="" class="form-label">Monto tarjeta</label>
                        <input type="number" class="form-control form-control-sm" v-model="monto_tarjeta">
                    </div>


                    <div v-if="tipo_pago == 'tarjeta' || tipo_pago == 'ambos'" class="col-sm-12 mt-3">
                        <label for="no_autorizacion" class="form-label">No. Autorización</label>
                        <input type="text" id="no_autorizacion" autocomplete="off" class="form-control form-control-sm"
                            v-model="no_autorizacion">
                    </div>

                    <div class="col-sm-12 mt-3">
                        <label for="comentarios" class="form-label">Comentarios</label>
                        <textarea id="comentarios" class="form-control form-control-sm"
                            v-model="comentarios"></textarea>
                    </div>

                    <div class="col-sm-12 mt-3 mb-3">
                        <button type="button" class="btn btn-sm btn-outline-dark btn-block"
                            @click="guardar_anticipo">Guardar</button>
                    </div>

                </b-row>
            </b-container>
        </div>
    </div>
</template>

<script>
    import { mapActions, mapState } from 'vuex'
    import { minix } from '@/components/functions/alertas'

    export default {
        name: 'ModalRegistroAnticipo',
        components: {
        },
        computed: {
            ...mapState(['datos_usuario', 'id_empresa_seleccionada', 'carrito_facturador', 'datos_cliente', 'datos_anticipo_modal'])
        },
        data() {
            return {
                monto: 0,
                monto_tarjeta: 0,
                tipo_pago: '',
                no_autorizacion: '',
                comentarios: ''
            }
        },
        methods: {
            cerrar() {
                this.$emit('salir')
            },
            async guardar_anticipo() {

                let monto = parseFloat(this.monto)
                let dif_tarjeta = parseFloat(this.monto_tarjeta)
                let monto_total = parseFloat(this.datos_anticipo_modal.saldo_pendiente)

                let f = {
                    api: `anticipos/r/abono`,
                    formulario: {
                        comentarios: this.comentarios,
                        usuario: this.datos_usuario.id,
                        sucursal: this.datos_usuario.sucursal_asignada,
                        empresa: this.id_empresa_seleccionada,
                        tipo_pago: this.tipo_pago,
                        correlativo_anticipo: this.datos_anticipo_modal.correlativo_anticipo
                    }
                }


                if (this.tipo_pago == 'efectivo') {
                    if (monto <= 0 || isNaN(monto) || monto == '') {
                        minix({ icon: 'info', mensaje: 'Ingrese un monto', tiempo: 3000 })
                        return
                    }

                    if (monto > monto_total) {
                        minix({ icon: 'info', mensaje: 'El monto no puede ser mayor al saldo pendiente', tiempo: 3000 })
                        return
                    }


                    f.formulario.monto = monto
                    f.formulario.dif_efectivo = 0
                    f.formulario.dif_tarjeta = 0

                } else if (this.tipo_pago == 'tarjeta') {

                    if (dif_tarjeta <= 0 || isNaN(dif_tarjeta) || dif_tarjeta == '') {
                        minix({ icon: 'info', mensaje: 'Ingrese un monto', tiempo: 3000 })
                        return
                    }

                    if (dif_tarjeta > monto_total) {
                        minix({ icon: 'info', mensaje: 'El monto no puede ser mayor al total', tiempo: 3000 })
                        return
                    }

                    if (this.no_autorizacion == '') {
                        minix({ icon: 'info', mensaje: 'Ingrese un no. autorización', tiempo: 3000 })
                        return
                    }

                    // Validate authorization number format and length
                    const authNumber = this.no_autorizacion.trim().replace(/\s+/g, '');
                    if (authNumber.length < 4) {
                        minix({ icon: 'info', mensaje: 'El número de autorización debe tener al menos 4 caracteres', tiempo: 3000 })
                        return
                    }

                    // Check for special characters using regex
                    if (!/^[a-zA-Z0-9]+$/.test(authNumber)) {
                        minix({ icon: 'info', mensaje: 'El número de autorización solo puede contener letras y números', tiempo: 3000 })
                        return
                    }

                    // Update the cleaned authorization number
                    f.formulario.no_autorizacion = authNumber;
                    f.formulario.monto = 0
                    f.formulario.dif_efectivo = 0
                    f.formulario.dif_tarjeta = dif_tarjeta

                } else if (this.tipo_pago == 'ambos') {

                    if (monto <= 0 || isNaN(monto) || monto == '') {
                        minix({ icon: 'info', mensaje: 'Ingrese un monto en efectivo', tiempo: 3000 })
                        return
                    }

                    if (dif_tarjeta <= 0 || isNaN(dif_tarjeta) || dif_tarjeta == '') {
                        minix({ icon: 'info', mensaje: 'Ingrese un monto en tarjeta', tiempo: 3000 })
                        return
                    }

                    if (monto + dif_tarjeta > monto_total) {
                        minix({ icon: 'info', mensaje: 'El monto no puede ser mayor al total', tiempo: 3000 })
                        return
                    }

                    if (this.no_autorizacion == '') {
                        minix({ icon: 'info', mensaje: 'Ingrese un no. autorización', tiempo: 3000 })
                        return
                    }

                    // Validate authorization number format and length
                    const authNumber = this.no_autorizacion.trim().replace(/\s+/g, '');
                    if (authNumber.length < 4) {
                        minix({ icon: 'info', mensaje: 'El número de autorización debe tener al menos 4 caracteres', tiempo: 3000 })
                        return
                    }
                    // Check for special characters using regex
                    if (!/^[a-zA-Z0-9]+$/.test(authNumber)) {
                        minix({ icon: 'info', mensaje: 'El número de autorización solo puede contener letras y números', tiempo: 3000 })
                        return
                    }
                    // Update the cleaned authorization number
                    f.formulario.no_autorizacion = authNumber;

                    f.formulario.monto = 0
                    f.formulario.dif_efectivo = monto
                    f.formulario.dif_tarjeta = dif_tarjeta
                }

                if (this.comentarios.trim() == '') {
                    minix({ icon: 'info', mensaje: 'Ingrese comentarios', tiempo: 3000 })
                    return
                }


                let r = await this.guardar_data(f)

                this.tipo_pago = ''
                this.monto = 0
                this.monto_tarjeta = 0
                this.no_autorizacion = ''
                this.comentarios = ''
                minix({ icon: 'success', mensaje: 'Anticipo registrado', tiempo: 3000 })
                this.$emit('actualizar_registros')
                this.$emit('salir')


            },
            ...mapActions(['guardar_data'])
        },
    }
</script>

<style></style>